const FUTURES_STOCK_STATUS = Object.freeze({
  NORMAL: 0,
  STOCK: 1,
})

const FUTURES_ORDER_TABLE_CONFIG = Object.freeze({
  DEFAULT: Object.freeze({
    stockStatus: FUTURES_STOCK_STATUS.NORMAL,
  }),
  STOCK: Object.freeze({
    stockStatus: FUTURES_STOCK_STATUS.STOCK,
  }),
})

export {
  FUTURES_STOCK_STATUS,
  FUTURES_ORDER_TABLE_CONFIG,
}
